<template>
    <Card>
<!--      <AjaxForm route="admin/Product/Add">-->
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4">
            <CustomInput v-model="product.title" name="title" type="text" label="عنوان" placeholder="عنوان"></CustomInput>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <CustomInput v-model="product.en_title"  type="text" name="en_title" label="عنوان انگلیسی" placeholder="عنوان انگلیسی"></CustomInput>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <CustomInput v-model="product.technical_code" type="text"  name="technical_code" label="کد فنی" placeholder="کد فنی"></CustomInput>
          </div>
          <div class="col-md-4 col-sm-6 col-12">
            <CustomInput v-model="product.main_category_id" type="select" name="main_category_id" reduce_select="_id"
                        :select-options="main_category_options"
                         :fetch-options="getMainProductCategoryForSelect" select-label="title" placeholder="دسته بندی اصلی"
                         label="دسته بندی اصلی"
            ></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput v-model="product.description" name="description" type="textarea" label="توضیحات" placeholder="توضیحات..."></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4 d-flex">
            <label class="mr-3">تصویر اصلی</label>
            <ImagePicker v-model="product.thumbnail" name="thumbnail"></ImagePicker>
          </div>
          <div class="col-12 col-sm-12 col-md-6 mt-2">
            <div class="form-group">
              <label class="">دسته بندی ها</label>
              <div class="">
                <v-select append-to-body @search="getProductCategoryForSelect"
                          v-model="product.categories"
                          :multiple="true" dir="rtl"
                          :options="category_options" label="title" placeholder="دسته بندی محصولات را انتخاب کنید"></v-select>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 mt-3 ">
              <div class="">
                <label>کلمات کلیدی</label>
                <div class="d-flex">
                  <input class="form-control mr-1"
                         v-model="key"
                         @keypress.enter.prevent="addKeyword"
                         type="text" placeholder="کلمه کلیدی را وارد کنید">
                  <button type="button" @click="addKeyword" class="btn btn-info"><i class="far fa-plus"></i></button>
                </div>
              </div>
            <div class="keywords">
              <div v-for="(key,index) in keywords" :key="key" class="item">{{key}}
                <input type="hidden" name="keywords[]" :value="key" readonly hidden>
                <i @click="keywords.splice(index,1)" class="far fa-times text-danger"></i>
              </div>
            </div>
            </div>
        </div>
      <div v-if="cat_attributes && cat_attributes.length" class="my-2">
        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
            <tr>
              <th style="width: 30%;">ویژگی</th>
              <th style="width: 70%;">مقادیر</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in cat_attributes" :key="item">
              <td>
                {{item.attr.title}}
              </td>
              <td>
                <CustomInput placeholder="انتخاب مقادیر" type="select" v-model="item.selected_items" :select_multiple="true" :select-options="item.items" select-label="title" without-label="true"></CustomInput>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="cat_attributes && cat_attributes.length" class="border p-1">
        <label class="font-weight-bold">انتخاب تصاویر برای ویژگی ها</label>
        <div class="attributes row">
          <div v-for="(item,index) in cat_attributes" class="col-12 col-md-4" :key="index">
            <label>{{item.attr.title}}</label>
            <div>
              <CustomInput v-model="item.selected" placeholder="انتخاب کنید" :without-label="true" type="select" name="" :select-options="item.items" select-label="title"></CustomInput>
            </div>
          </div>
          <div class="col-12 col-md-3 d-flex flex-column justify-content-center">
            <button class="btn btn-info btn-sm mb-1" type="button" @click="addAttribute">افزودن ویژگی</button>
          </div>
        </div>
        <div class="pics-div">
          <div v-for="(item,index) in attr_obj" :key="item">
            <div class="img">
              <ImagePicker v-model="item.pic_id"></ImagePicker>
            </div>
            <div class="my-1">
              {{item.title}}
            </div>
            <button @click="deleteAttrItem(index)" class="btn btn-danger btn-sm mt-1 btn-block">حذف</button>
          </div>
        </div>
      </div>

        <div class="row">
          <div class="col-12 col-sm-10 col-md-5 mx-auto mt-3">
            <button ref="submitBtn" @click="submitProduct" class="btn btn-info btn-block">ثبت محصول</button>
          </div>
        </div>
<!--      </AjaxForm>-->
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import vSelect from 'vue-select'
import ImagePicker from "@/components/ImagePicker";
import ImagePickerGallery from "@/components/ImagePickerGallery";
import {ProductApi} from "@/api/ProductApi";
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import {searchArray, showSystemNoti} from "@/shared/helper";
export default {
  name: "ProductAdd",
  components: {ImagePickerGallery, ImagePicker, CustomInput, AjaxForm, Card, MasterLayout,vSelect},
  data()
  {
    return{
      product : {},
      categories : [],
      category_options : [],
      main_category_options : [],
      key : '',
      keywords : [],
      pic_items : [],
      attr_obj : [],
      cat_attributes : [],
    }
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async getProductCategoryForSelect(search, loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getNoChildForSelectWithGuild(search);
        if (data.ok)
        {
          this.category_options = data.cats;
        }
        else
          this.category_options = [];
      }
      loading(false);
    },
    async getMainProductCategoryForSelect(search, loading)
    {
      loading(true);
      if (search.length > 1)
      {
        const data = await ProductApi.getNoChildForSelectWithGuild(search);
        if (data.ok)
        {
          this.main_category_options = data.cats;
        }
        else
          this.main_category_options = [];
      }
      loading(false);
    },
    addKeyword()
    {
      if (this.key)
      {
        if (!searchArray(this.keywords, this.key))
          this.keywords.push(this.key);
      }
    },
    async changeMainCategory()
    {
      this.setPageLoading(true);
      this.cat_attributes = [];
      this.attr_obj = [];
      //اینجا باید عناوین ویژگی ها بردارم با تمامی مقادیر و افزودن رو براش بزام که هر کدوم رو خواست براش ویژگی درست بکنه
      if (this.product.main_category_id)
      {
        const result = await ProductApi.getCategoryAttributeForAddProduct(this.product.main_category_id._id);
        // const result = await ProductApi.getCategoryAttributes(this.main_category_id._id);
        if (result.ok)
        {
          this.cat_attributes = result.attributes;
          this.attr_obj = result.attr_obj;
        }
        else
          this.pic_items = [];
      }
      for (let i = 0; i < this.cat_attributes.length; i++)
      {
        this.cat_attributes[i].selected_items = this.cat_attributes[i].default_items;
      }
      this.setPageLoading(false);
    },
    async addAttribute()
    {
      const final_attr = [];
      const attr = this.cat_attributes;
      if (!attr)
        return showSystemNoti('danger','ویژگی یافت نشد.');
      let title = '';
      for (let i = 0; i < attr.length; i++)
      {
        const item = attr[i];
        if (item.selected)
        {
          //اینجا مقدار آیتم رو داریم
          title += '(' + item.selected.attribute_title + ':' + item.selected.title + ')';
          final_attr.push(item.selected);
        }
        // else
        //   return showSystemNoti('danger', 'باید ویژگی را انتخاب کنید.');
      }
      if (!final_attr.length)
        return showSystemNoti('danger', 'باید حداقل یک ویژگی را انتخاب کنید.');
      const attr_obj = this.attr_obj;
      for (let i = 0;i<attr_obj.length;i++)
      {
        if (JSON.stringify(attr_obj[i].attr) === JSON.stringify(final_attr))
          return showSystemNoti('danger','ویژگی انتخاب شده درلیست موجود می باشد.');
      }
      this.attr_obj.push({title: title, attr: final_attr});
    },
    deleteAttrItem(index)
    {
      this.attr_obj.splice(index,1);
    },
    async submitProduct()
    {
      const attributes = [];
      const cat_attributes = this.cat_attributes?this.cat_attributes:[];
      for (let i = 0; i < cat_attributes.length; i++)
      {
        const c = cat_attributes[i];
        const item = {};
        item.attr_id = cat_attributes[i].attr._id;
        const item_ids = [];
        const selected_items  = c.selected_items;
        if (selected_items && selected_items.length)
        {
          for (let j = 0; j < selected_items.length; j++)
          {
            item_ids.push(selected_items[j]._id);
          }
        }
        item.attr_item_ids = item_ids;
        attributes.push(item);
        //باید ویژگی هایی که تو دسته بندی انتخاب شده باید انتخاب کند
      }
      this.setPageLoading(true);
      this.product.attrs = this.attr_obj;
      this.product.attributes = attributes;
      this.product.keywords = this.keywords;
      const result = await ProductApi.addProduct(this.product);
      if (result.ok)
      {
        showSystemNoti('success',result.message);
      }
      else
        showSystemNoti('danger',result.error);
      this.setPageLoading(false);

    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('افزودن محصول');
    this.setShowHead(true);
  },
  watch : {
    'product.main_category_id' : {
      handler()
      {
        this.changeMainCategory();
      },deep : true
    },
  }
}
</script>

<style scoped>
.pics-div {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 10px 0;
  text-align: center;
  width: 100%;
  flex-wrap: wrap;
}
.pics-div >div
{
  width: 120px;
  flex: 0 0 110px;
}
.pics-div .img
{
  margin: 0 auto;
  width: max-content;
}
.keywords
{
  display: flex;
  flex-wrap: wrap;
}
.keywords .item {
  width: max-content;
  padding: 5px;
  border-radius: 7px;
  background: #17a2b8;
  color: white;
  margin-top: 5px;
  margin-left: 3px;
}
</style>